module.exports = __webpack_public_path__ + "static/media/take-out-food.5cb276a5.png";